import { render, staticRenderFns } from "./shenpi.vue?vue&type=template&id=b74975c4&scoped=true&"
import script from "./shenpi.vue?vue&type=script&lang=js&"
export * from "./shenpi.vue?vue&type=script&lang=js&"
import style0 from "./shenpi.vue?vue&type=style&index=0&id=b74975c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74975c4",
  null
  
)

export default component.exports